import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import styles from "../SchedaSpecialeArbovirosi.module.css";
import Utils from "../../../../../../../utils/Utils";

class StatoVaccinale extends Component {
    
    state = {
        StatoVaccinale: {
            tbe: "",
            febbreGialla: "",
            encefaliteGiapponese: "",
            corretto: []
        }
    };

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this);
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this);
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia?.schedaSpeciale?.statoVaccinale) {
            this.setState({
                StatoVaccinale: {
                    ...this.state.StatoVaccinale,
                    ...JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.statoVaccinale)),
                    corretto: []
                }
            }, () => this.aggiornaPadre());
        } else {
            this.aggiornaPadre();
        }
    }

    riceviValore(arg1, arg2) {
        let statoVaccinale = this.state.StatoVaccinale;
        let field, valore;

        // ALLINEATO: logica robusta identica a classificazioneDelCaso
        if (typeof arg1 === "string" && arg2 && arg2.target) {
            // Chiamata con (field, event) — es. onClick={this.riceviValore} con field passato come primo arg
            field = arg1;
            valore = arg2.target.value;
        } else if (typeof arg1 === "string" && typeof arg2 === "string") {
            // Chiamata diretta con (field, value) — valore già estratto
            field = arg1;
            valore = arg2;
        } else if (arg1 && arg1.target) {
            // Chiamata con solo l'evento sintetico
            field = arg1.target.id || arg1.target.name;
            valore = arg1.target.value;
        }

        if (field) {
            statoVaccinale[field] = valore;
            this.setState({ StatoVaccinale: statoVaccinale }, () => {
                this.aggiornaPadre();
            });
        }
    }

    aggiornaPadre() {
        this.controlloCorrettezza();
        if (this.props.controlloCorrettezza) this.props.controlloCorrettezza();

        let oggettoBE = this.createOggettoBE();

        if (this.props.setStatoVaccinale) {
            // ALLINEATO: passa sia lo state completo (con corretto) che l'oggetto BE pulito
            this.props.setStatoVaccinale(this.state.StatoVaccinale, oggettoBE);
        }
    }

    controlloCorrettezza() {
        let dati = this.state.StatoVaccinale;
        dati.corretto = [];
        // Nessun campo obbligatorio per StatoVaccinale — array resta vuoto
    }

    createOggettoBE() {
        let copiaDati = JSON.parse(JSON.stringify(this.state.StatoVaccinale));
        let pulito = Utils.removeEmptyValueFromObject(copiaDati);
        return Utils.removeFieldFromObject(pulito, "corretto");
    }

    render() {
        const { t } = this.props;
        const { StatoVaccinale: data } = this.state;
        const path = "SchedaSpecialeArbovirosi.StatoVaccinale";

        const labelSi      = t("SchedaSpecialeTubercolosi.si");
        const labelNo      = t("SchedaSpecialeTubercolosi.no");
        const labelNonNoto = t("SchedaSpecialeTubercolosi.nonNoto");

        const listaVaccini = [
            { id: "tbe",         field: "tbe",                  label: t(`${path}.labels.tbe`) },
            { id: "febbreGialla", field: "febbreGialla",         label: t(`${path}.labels.febbreGialla`) },
            { id: "encefalite",  field: "encefaliteGiapponese",  label: t(`${path}.labels.encefaliteGiapponese`) }
        ];

        const opzioniRisposte = [
            { val: "01", label: labelSi },
            { val: "02", label: labelNo },
            { val: "03", label: labelNonNoto }
        ];

        return (
            <div className={"container"}>
                <div style={{marginTop: "10px"}}/>
                <div className={"row"} style={{marginTop: "20px"}}>
                    <div className={"col-lg-4"}>
                        <p style={{fontWeight: "600"}}>
                            {t(`${path}.titolo`)}
                        </p>
                    </div>
                </div>

                {listaVaccini.map((v) => (
                    <div key={v.id} className="row mb-3 align-items-center">
                        <div className="col-lg-4">
                            <p style={{ fontWeight: "600", margin: 0 }}>{v.label}</p>
                        </div>

                        <div className="col-lg-6">
                            <div className="d-flex">
                                {opzioniRisposte.map(opt => (
                                    <div key={v.id + opt.val} style={{ marginRight: "20px" }}>
                                        <RadioButton
                                            id={v.id + opt.val}
                                            name={v.field}
                                            label={opt.label}
                                            value={opt.val}
                                            field={v.field}
                                            checked={data[v.field] === opt.val}
                                            onClick={this.riceviValore}
                                            newRadio={true}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}

export default withTranslation('common')(StatoVaccinale);